import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { AuthProvider } from '../../providers/auth/auth';
import { Observable } from 'rxjs';
import { DatabaseProvider } from '../../providers/database/database';

@IonicPage()
@Component({
  selector: 'page-clinic-doctors',
  templateUrl: 'clinic-doctors.html',
})
export class ClinicDoctorsPage {

  public doctorsList: Observable<any[]>;
  clinic_name: string = null;
  clinic_id: string = null;

  constructor(
    public navCtrl: NavController, 
    public alertCtrl: AlertController,
    public navParams: NavParams, 
    private auth: AuthProvider, 
    private database: DatabaseProvider
    ) {
    this.auth.getCurrentUser().then(user => {
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;

      this.doctorsList = this.database
      .getDoctorsByClinic(this.clinic_id)
      .snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      });
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ClinicDoctorsPage');
  }

  deleteDoctor(doctor)  {
    console.log(doctor);
    let confirm = this.alertCtrl.create({
      title: "Delete Doctor",
      message:
        "Are you sure you would like to delete this doctor?",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            this.database.deleteDoctor(this.clinic_id, doctor.id).then(() => {
              console.log('Successfully deleted the doctor');
            })
            .catch((error) => {
              console.log('Error deleting doctor');
            });
          }
        }
      ]
    });
    confirm.present();
  }

  editDoctor(doctor)  {
    console.log(doctor.id);
    const prompt = this.alertCtrl.create({
      title: 'Edit Dr. ' + doctor.first_name + ' ' + doctor.last_name,
      message: "Enter the first name, last name and license number",
      inputs: [
        {
          name: 'first_name',
          placeholder: 'First Name',
          value: doctor.first_name
        },
        {
          name: 'last_name',
          placeholder: 'Last Name',
          value: doctor.last_name
        }, {
          name: 'license_number',
          placeholder: 'License Number',
          value: doctor.license_number
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Update',
          handler: data => {
            this.database.updateDoctor(this.clinic_id, doctor.id, data).then(() => {
              console.log('Successfully updated the doctor');
            })
            .catch((error) => {
              console.log('Error updating the doctor');
            });
          }
        }
      ]
    });
    prompt.present();
  }

  addDoctor() {
    const prompt = this.alertCtrl.create({
      title: 'Add New Doctor',
      message: "Enter the first name, last name and license number",
      inputs: [
        {
          name: 'first_name',
          placeholder: 'First Name'
        },
        {
          name: 'last_name',
          placeholder: 'Last Name'
        }, {
          name: 'license_number',
          placeholder: 'License Number'
        },
      ],
      buttons: [
        {
          text: 'Cancel',
          handler: data => {
            console.log('Cancel clicked');
          }
        },
        {
          text: 'Save',
          handler: data => {
            this.database.addDoctor(this.clinic_id, data).then(() => {
              console.log('Successfully added the doctor');
            })
            .catch((error) => {
              console.log('Error adding the doctor');
            });
          }
        }
      ]
    });
    prompt.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/clinic-doctors/clinic-doctors.ts